import InsertNamesToTable from "../names/InsertNamesToTable";
import { fetchPostDocket } from "../../../faetures/fetch";
import myImage1 from "../../../images/logo-aufa.png";
import myImage2 from "../../../images/logo-aufa_all.png";


export default function SearchData ({data, setNames, setMassage, numOfDocket, setClose}) {

    function dubalClick (key) {
        setMassage({open: true, text: ""});
        if (numOfDocket !== 0) {
            fetchPostDocket('insert-names', {num: numOfDocket, user: key}).then((resolve) => {
                if (resolve === 'okay') {
                    setMassage({open: false, text: ''});
                    setNames(key, data[key]);
                } else {
                    setMassage({open: true, text: 'שגיאה'});
                }
            }).catch(() => {
                setMassage({open:true, text: 'שגיאה בשרת ! נסה שוב בעוד כמה דקות'});
            })
        } else {
            setMassage({open: false, text: ''});
            setNames(key, data[key]);
        }
    }

    return (
        <div className="searchData scrool">
            {
                Object.keys(data).length ? 
                <InsertNamesToTable data={data} onDoubleClick={dubalClick} /> : 
                <div className="image-search-logo">
                    <img src={myImage1} />
                    <img src={myImage2} />
                </div>
            }
        </div>
    )
}
           